<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-07-09 15:48:50
 * @LastEditTime: 2019-09-07 11:55:22
 * @LastEditors: Please set LastEditors
 -->
<template>
      <el-dialog
            title="查看"
            :visible="true"
            width="85%"
            :append-to-body=true
            :before-close="handleClose">
                   <div class="productBox">
                             <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
                                    <el-tab-pane label="非赠品" name="first">
                                          <el-tabs v-model="first_active" @tab-click="handleClickfirst">
                                        <el-tab-pane :label="value.attribute_name" :name="'attr-'+value.attribute_id"  v-if='is_show_attribute||index==0' v-for='(value,index) in attrList' :key='index'></el-tab-pane>

                                            
                                            </el-tabs>
                                    </el-tab-pane>
                                    <el-tab-pane label="赠品" name="second">
                                       
                                    </el-tab-pane>
                                  
                                </el-tabs>
                             <!--表格-->
            <el-table
            ref="multipleTable"
            :data="tableData"
            v-loading="loading"
            
            border
            stripe
            fit
            style="width: 100%"
            >

      <el-table-column prop="product_sn" label="产品图片" >
          <template slot-scope="scope" class='input'>
              <img :src="scope.row.product_img" alt="">
          </template>
      </el-table-column>

      <el-table-column prop="product_sn" label="产品编号" ></el-table-column>
      <el-table-column prop="product_name"  label="产品名称" ></el-table-column>
     
      <el-table-column prop="product_specs"  label="产品规格" ></el-table-column>
      <el-table-column prop="price"  label="价格" >
      </el-table-column>
    </el-table>
 
                       </div>
        </el-dialog>
</template>


<script>
export default {
    name:'specifyDetail',
    data(){
        return{
            loading:false,
            activeName:'first',
            first_active:'first',
            second_active:'first',

            tableData:[],
            isgift:[],
            istgift:[],
            flag:1,
            attrList:[],
            is_show_attribute:0
        }
    },
    props:{
        putaway:Object
    },
    methods:{
        init(){
            var url='/specify.putaways/'+this.putaway.putaway_id
            this.$get('logistics',url).then(res=>{
                console.log(res)
                this.isgift=res.data.products[0].products
                this.isgiftData0=this.isgift
                this.istgift=res.data.products[1].products
                if(this.is_show_attribute==0){
                    this.tables=this.istgift
                }else{
                     this.istgift.forEach(element => {
                      // if(element.attribute_id&&Number(element.attribute_id)==0){
                      //       this.istgiftData1.push(element)
                      //   }else{
                      //       this.istgiftData0.push(element)
                      //   }
                     this['tablesattr-'+element.attribute_id].push(element)
                     })
                }
                this.tabType()
                
            })
        },
                getAttr(){
                this.$get('logistics','/configs.order').then(res=>{
                    if(res.data.product_attribute_on_off==1){
                    this.is_show_attribute=1
                    this.$get('logistics','/product.attributes').then(res=>{
                        this.attrList=res.data
                        res.data.forEach(element => {
                            if(element.is_default==1){
                            this.first_active='attr-'+element.attribute_id
                            }
                            this['tablesattr-'+element.attribute_id]=[]
                        });
                    this.init()

                    })
                    }else{
                    this.is_show_attribute=0
                    this.init()
                    }
                })
                
        },
        handleClose(){
            this.$emit('handleClose')
        },
        handleClick(value){
              this.tabType()
        },
        handleClickfirst(value){
              this.tabType()
        },
        handleClicksecond(value){
              this.tabType()
        },
     tabType(){

            if(this.activeName=='first'&&this.is_show_attribute==1){
               
                this['tables'+this.first_active]=this['tables'+this.first_active],'product_sn'
                // this.istgiftData0=
                 this.tableData = this['tables'+this.first_active]
                 this.tables= this['tables'+this.first_active]
                //  this.flag=1
            }else{
              
               this.tableData=this.tables
            }
            if(this.activeName=='second'){
                //   this.isgiftData0=this.Unique(this.isgiftData0,'product_sn')
                   this.tableData =this.isgiftData0
                  this.tables=this.isgiftData0

                    // this.flag=3
            }
        },
    },
    created(){
        this.init()
        this.getAttr()
    }
}
</script>
